import { cn } from '@/shared/lib/cn';

type BadgeVariant = 'overdue' | 'active' | 'draft' | 'due' | 'confirm' | 'credit' | 'holder';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label: string;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  overdue:
    'text-status-debt bg-[rgba(229,42,48,0.12)] border border-[rgba(193,7,16,0.28)]',
  active:
    'text-status-paid bg-[rgba(0,153,40,0.14)] border border-[rgba(0,153,40,0.30)]',
  draft:
    'text-text-secondary bg-[rgba(18,52,36,0.08)] border border-[rgba(18,52,36,0.16)]',
  due:
    'text-status-warn bg-[rgba(230,103,53,0.15)] border border-[rgba(230,103,53,0.30)]',
  confirm:
    'text-status-warn bg-[rgba(230,103,53,0.14)] border border-[rgba(230,103,53,0.32)]',
  credit:
    'text-status-credit bg-[rgba(12,143,128,0.10)] border border-[rgba(12,143,128,0.24)]',
  holder:
    'text-[#138a5b] bg-[rgba(0,153,40,0.12)] border border-[rgba(0,153,40,0.30)]',
};

export function StatusBadge({ variant, label, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-block text-[11px] font-semibold rounded-full px-[9px] py-[3px]',
        variantClasses[variant],
        className,
      )}
    >
      {label}
    </span>
  );
}
